__turbopack_context__.v({
  "Footer": "Footer-module__3LCtpa__Footer",
  "FooterBottom": "Footer-module__3LCtpa__FooterBottom",
  "activeLink": "Footer-module__3LCtpa__activeLink",
  "bottom": "Footer-module__3LCtpa__bottom",
  "button": "Footer-module__3LCtpa__button",
  "footerLinks": "Footer-module__3LCtpa__footerLinks",
  "form": "Footer-module__3LCtpa__form",
  "input": "Footer-module__3LCtpa__input",
  "item": "Footer-module__3LCtpa__item",
  "left": "Footer-module__3LCtpa__left",
  "link": "Footer-module__3LCtpa__link",
  "list": "Footer-module__3LCtpa__list",
  "right": "Footer-module__3LCtpa__right",
  "row": "Footer-module__3LCtpa__row",
  "socialLink": "Footer-module__3LCtpa__socialLink",
  "socialLinks": "Footer-module__3LCtpa__socialLinks",
  "store": "Footer-module__3LCtpa__store",
  "text": "Footer-module__3LCtpa__text",
  "title": "Footer-module__3LCtpa__title",
  "top": "Footer-module__3LCtpa__top",
});
